<div class="col-11 col-sm-11 col-md-11 col-lg-11 col-xl-11 text-center m-auto  ">


  <!-- formulaire enrollement -->
  <div class="card"  style="padding: 10px;">
    <div class="d-flex justify-content-center">
      <h5 id="heading">Ajout Fonction</h5>
      <button type="button"  class="btn btn-link position-absolute" style="top: 10px; right: 10px;" aria-label="Close" (click)="closeModal()">
        <i class="fas fa-times text-dark" style="font-size: 1.5rem; "></i>
      </button>
    </div>
   <!-- <p>Fill all form field to go to next step</p> -->
   <form #form="ngForm" (ngSubmit)="onSubmit(form)"  novalidate id="msform" >
       <!-- progressbar -->
       <ul id="progressbar">
           <li class="active" id="step1"><strong>Information du tribunal </strong></li>

          <!--  <li id="step3"><strong>Configurations chambre/cabinet</strong></li> -->

       </ul>
       <div class="progress">
           <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuemin="0" aria-valuemax="100"></div>
       </div> <br><br> <!-- fieldsets -->
       <fieldset class="step1">
        <div class="form-card">

          <div class="d-flex justify-content-between flex-wrap ">
            <div class="col-md-12 mb-12" style="padding: 0 5px 0 0;">
              <div class="d-flex">
                <div>
                  <label class="fieldlabels">Nom de la fonction:* </label>
                  <input  type="text" class="form-control" name="nom" ngModel [(ngModel)]="default_value" required />
                </div>
                <div>
                  <span class="text-nowrap">Est une fonction du tribunal?: <input  type="checkbox" [checked]="isJudiciaire" [disabled]="isJudiciaire" class="form-control" name="is_judiciaire" [(ngModel)]="isJudiciaire" ngModel required /> </span>
                </div>
              </div>
                
              <ng-container *ngIf="isJudiciaire">
                <label class="fieldlabels">Profil Associe: </label>
                <select class="custom-select" id="inputGroupSelect01"  name="profil_associer" ngModel>
                  <option [value]="item.name" *ngFor="let item of list_profil">{{item.name}}</option>
                </select>
              </ng-container>
             

                <label class="fieldlabels">Description: </label>
                <textarea class="form-control" style="height: 120px;" name="description"  ngModel></textarea>


            </div>
        </div>

        </div>
        <input  type="submit" class="action-button" value="Enregistrer" />&nbsp;
        <!-- <input type="button" name="Précédent" class="previous action-button-previous" value="Précédent" /> -->


        </fieldset>





   </form>


</div>
